@if (kind(); as alertKind) {
  <div
    class="modal fade show d-block connectivity-alert-modal"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="alertKind === 'offline' ? 'connectivityOfflineTitle' : 'connectivityServerTitle'"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content connectivity-alert-modal__content">
        @if (alertKind === 'offline') {
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title" id="connectivityOfflineTitle">Connessione assente</h5>
          </div>
          <div class="modal-body pt-2">
            <div class="d-flex align-items-start gap-3">
              <!-- Icona Bootstrap Icons -->
              <span class="connectivity-alert-modal__icon text-warning flex-shrink-0" aria-hidden="true">
                <i class="bi bi-wifi-off fs-2"></i>
              </span>
              <p class="mb-0 connectivity-alert-modal__text">
                Nessuna connessione a Internet. Controlla la rete: l'avviso scomparirà automaticamente al ripristino.
              </p>
            </div>
          </div>
        } @else {
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title" id="connectivityServerTitle">Server non raggiungibile</h5>
          </div>
          <div class="modal-body pt-2">
            <div class="d-flex align-items-start gap-3">
              <!-- Icona Bootstrap Icons -->
              <span class="connectivity-alert-modal__icon text-warning flex-shrink-0" aria-hidden="true">
                <i class="bi bi-cloud-slash fs-2"></i>
              </span>
              <p class="mb-0 connectivity-alert-modal__text">
                Impossibile contattare il server. Riprova tra poco oppure usa il pulsante qui sotto.
              </p>
            </div>
          </div>
          <div class="modal-footer border-0 pt-0">
            <button
              type="button"
              class="btn btn-primary d-inline-flex align-items-center"
              [disabled]="retrying()"
              (click)="onRetry()"
            >
              @if (retrying()) {
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              } @else {
                <span class="me-2 d-inline-flex" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                  </svg>
                </span>
              }
              Riprova
            </button>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show connectivity-alert-modal__backdrop"></div>
}
